// UI strings of the legal and ethical notices (AI disclaimer, data usage, terms, contact), English only.
// Merged into the i18next resources in ../i18n.js. Use as t("legal.<key>"); outside React use i18n.t(...).

const en = {
	dataSource: "Data source:",
	dataLicense: "License:",
	aiDisclaimer: "You are interacting with an AI assistant. Responses are automatically generated and may contain errors.",
	aiDisclaimerLink: "How we use your data",
	ewsHelp: {
		title: "About this map",
		summary: "This map shows the expected change in crop yield in each region, compared with a normal year. Red regions expect a bigger drop; grey regions have no forecast. Click a region to see its details.",
		aboutTitle: "What is the Early Warning System?",
		about: "A model that estimates how this year's weather and climate disasters (heatwaves, droughts, coldwaves, storms and heavy rain) will affect maize yield across the EU.",
		howTitle: "How it works",
		how: "The model takes the latest weather data and forecasts the yield. That forecast is compared with a normal year, the 1990-2020 average, and each region gets a warning level.",
		showsTitle: "What it shows",
		shows: "Each region (NUTS3) is coloured by its forecast change in crop yield, compared with its baseline yield.",
		readTitle: "How to read it",
		read: "Colours follow the legend, from {{first}} (largest forecast drop) to {{last}}. The dashboard shows the forecast level; it does not recalculate it.",
		levelsIntro: "Legend",
		noForecast: "Grey: no forecast.",
		popupTitle: "Details",
		popup: "Click a region to see its predicted yield, percent change, level and baseline yield.",
		limitsTitle: "Limits",
		limits: "Forecasts are uncertain. Treat them as an early signal, not a measured result.",
	},
	legalPages: {
		navLabel: "Legal and contact",
		privacyLink: "Data use & privacy",
		privacyLinkShort: "Data & privacy",
		termsLink: "Terms",
		contactLink: "Contact / report a problem",
		contactLinkShort: "Contact",
		privacyTitle: "How we use your data",
		termsTitle: "Terms and conditions",
		termsVersion: "Version {{version}}",
		englishOnly: "The legal text is available in English only.",
		useNotice: "By using this service, you acknowledge that you have read and agree to our <terms>Terms of Service</terms> and <privacy>Privacy Policy</privacy>.",
	},
	contact: {
		title: "Contact / Report a problem",
		typeLabel: "Type",
		types: { bug: "Bug", question: "Question", other: "Other" },
		messageLabel: "Message",
		messageHelp: "{{count}} / {{max}} characters (at least {{min}})",
		pageLabel: "Page",
		pageHelp: "The name of this page and your browser version are sent with your message. Replies go to your account email address.",
		cancel: "Cancel",
		send: "Send",
		sending: "Sending...",
		success: "Thank you. Your message was sent.",
		errorTooShort: "Please write at least {{min}} characters.",
		errorTooLong: "Please keep your message under {{max}} characters.",
		errorValidation: "Your message could not be accepted. Please check the type and the text and try again.",
		errorRateLimit: "You have sent too many reports. Please try again in an hour.",
		errorGeneric: "Your message could not be sent. Please try again later.",
		notFoundTitle: "404, Page not found!",
		notFoundText: "The page you requested was not found. If you believe something is wrong please <contact>contact us</contact>.",
		notFoundBack: "Go Back",
	},
};


export const legalResources = { en };
